import { useTranslation } from '@instanexus/i18n';
import { TurnstileWidget } from '@instanexus/ui';
import type { ReactElement } from 'react';

import type { UseCaptcha } from '@/hooks/use-captcha';

/**
 * The Turnstile challenge for a form, labelled and translated. With no site key in the build it
 * renders a visible configuration error instead of a widget — the form never silently submits
 * without a challenge (its submit stays disabled while `captcha.token` is null).
 */
export function CaptchaField({ captcha }: { readonly captcha: UseCaptcha }): ReactElement {
  const { t } = useTranslation('auth');
  if (!captcha.isConfigured) {
    return (
      <p role="alert" className="text-danger text-sm text-pretty">
        {t('captcha.missingKey')}
      </p>
    );
  }
  return (
    <TurnstileWidget
      ref={captcha.widgetRef}
      siteKey={captcha.siteKey}
      onToken={captcha.setToken}
      label={t('captcha.label')}
      loadErrorText={t('captcha.loadError')}
    />
  );
}
